/**
 * The same password rules the server enforces (backend routes/auth.py validate_password), shown
 * as a live checklist so nobody has to guess why "8 characters" was not enough.
 */
export const PASSWORD_RULES = [
  { id: 'length', label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { id: 'upper', label: 'A capital letter (A to Z)', test: (p) => /[A-Z]/.test(p) },
  { id: 'lower', label: 'A lowercase letter (a to z)', test: (p) => /[a-z]/.test(p) },
  { id: 'number', label: 'A number (0 to 9)', test: (p) => /[0-9]/.test(p) },
  { id: 'special', label: 'A symbol, like ! @ # $ % or ?', test: (p) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(p) },
];

export const passwordChecks = (password = '') => PASSWORD_RULES.map((rule) => ({ ...rule, ok: rule.test(password) }));
export const passwordOk = (password = '') => PASSWORD_RULES.every((rule) => rule.test(password));
